import cx from 'classnames'

import style from './HubWidget.module.scss'
import Draggable from 'react-draggable'
import { useMemo, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import { displayModal } from '../../storage/emitter'

import livetvBig from 'assets/images/placeholders/livetv-big.jpg'
import livetvMedium from 'assets/images/placeholders/livetv-medium.jpg'
import livetvSmall from 'assets/images/placeholders/livetv-small.jpg'

import musicBig from 'assets/images/placeholders/music-big.jpg'
import musicMedium from 'assets/images/placeholders/music-medium.jpg'
import musicSmall from 'assets/images/placeholders/music-small.jpg'

import radioBig from 'assets/images/placeholders/radio-big.jpg'
import radioMedium from 'assets/images/placeholders/radio-medium.jpg'
import radioSmall from 'assets/images/placeholders/radio-small.jpg'

import vodBig from 'assets/images/placeholders/vod-big.jpg'
import vodMedium from 'assets/images/placeholders/vod-medium.jpg'
import vodSmall from 'assets/images/placeholders/vod-small.jpg'

import weatherBig from 'assets/images/placeholders/weather-big.jpg'
import weatherMedium from 'assets/images/placeholders/weather-medium.jpg'
import weatherSmall from 'assets/images/placeholders/weather-small.jpg'

const widgetImages = {
  livetv: {
    big: livetvBig,
    medium: livetvMedium,
    small: livetvSmall,
  },
  music: {
    big: musicBig,
    medium: musicMedium,
    small: musicSmall,
  },
  radio: {
    big: radioBig,
    medium: radioMedium,
    small: radioSmall,
  },
  vod: {
    big: vodBig,
    medium: vodMedium,
    small: vodSmall,
  },
  weather: {
    big: weatherBig,
    medium: weatherMedium,
    small: weatherSmall,
  },
}

const HubWidget = (props) => {
  const nodeRef = useRef(null)
  return (
    <Draggable {...props} nodeRef={nodeRef}>
      {props.children}
    </Draggable>
  )
}

export const LiveTVWidget = (props) => {
  const history = useHistory()
  const classes = cx(props.className, 'widget', 'widget-livetv', style.widget)
  const { size } = props;
  const image = useMemo(() => widgetImages.livetv[size], [size])
  return (
    <HubWidget {...props} className={undefined}>
      <div
        className={classes}
        data-position={props['data-position']}
        onClick={() => {
          history.push('/live')
        }}
      >
        <img alt="Live TV Widget" src={image}/>
      </div>
    </HubWidget>
  )
}

export const MusicWidget = (props) => {
  const history = useHistory()
  const classes = cx(props.className, 'widget', 'widget-music', style.widget)
  const { size } = props;
  const image = useMemo(() => widgetImages.music[size], [size])

  return (
    <HubWidget {...props} className={undefined}>
      <div
        className={classes}
        data-position={props['data-position']}
        onClick={() => {
          history.push('/music');
        }}
      >
        <img alt="Music Widget" src={image}/>
      </div>
    </HubWidget>
  )
}

export const RadioWidget = (props) => {
  const classes = cx(
    props.className,
    'widget',
    'widget-radio',
    style.widget,
    style.widgetRadio,
  )
  const { size } = props;
  const image = useMemo(() => widgetImages.radio[size], [size])

  return (
    <HubWidget {...props} className={undefined}>
      <div
        className={classes}
        data-position={props['data-position']}
        onClick={() => {
          displayModal('demo')
        }}
      >
        <div className={cx('widget-background', style.widgetBackground)}>
          <div
            className={cx(
              'widget-background-image',
              style.widgetBackgroundImage,
            )}
          />
          <div
            className={cx(
              'widget-background-overlay',
              style.widgetBackgroundOverlay,
            )}
          />
        </div>
        <img alt="Radio Widget" src={image}/>
      </div>
    </HubWidget>
  )
}

export const VODWidget = (props) => {
  const history = useHistory()
  const classes = cx(props.className, 'widget', 'widget-vod', style.widget)
  const { size } = props;
  const image = useMemo(() => widgetImages.vod[size], [size])

  return (
    <HubWidget {...props} className={undefined}>
      <div
        className={classes}
        data-position={props['data-position']}
        onClick={() => {
          history.push('/vod')
        }}
      >
        <img alt="VOD Widget" src={image}/>
      </div>
    </HubWidget>
  )
}

export const WeatherWidget = (props) => {
  const classes = cx(props.className, 'widget', 'widget-weather', style.widget)
  const { size } = props;
  const image = useMemo(() => widgetImages.weather[size], [size])

  return (
    <HubWidget {...props} className={undefined}>
      <div
        className={classes}
        data-position={props['data-position']}
        onClick={() => {
          displayModal('demo')
        }}
      >
        <img alt="Weather Widget" src={image}/>
      </div>
    </HubWidget>
  )
}

export default HubWidget
